import type { ItemWithPropertiesType } from "./ItemKindConstants";
import type { PropertyPaneConfig } from "legacy/constants/PropertyControlConstants";

const propertyPaneConfigsRegistry = new Map<
  ItemWithPropertiesType,
  readonly PropertyPaneConfig[]
>();

export function getItemPropertyPaneConfig(
  type: ItemWithPropertiesType,
): readonly PropertyPaneConfig[] {
  return propertyPaneConfigsRegistry.get(type) ?? [];
}
